import { WidgetProps } from '@features/dashboard/types';
import { ChartWidgetPayload } from '@protos/charts';
import Widget, { Content, Header, HeaderRight } from '../Widget';
import Settings from '../settings/Settings';
import ChartProvider from './ChartContext';
import { ChartContainer } from './trading-view/ChartContainer';
import { ChartSearchCheatSheet } from './components/ChartSearchCheatSheet';
import { useWidgetLifecycleTelemetry } from '../useWidgetLifecycleTelemetry';

type ChartWidgetProps = WidgetProps & {
  payload?: ChartWidgetPayload;
};

export default function Chart({ payload, ...otherProps }: ChartWidgetProps) {
  const { id, title } = otherProps;
  useWidgetLifecycleTelemetry(id, title, 'ChartWidget', payload);

  return (
    <Widget {...otherProps}>
      <ChartProvider widgetId={id} initialValues={payload ?? {}}>
        <Header title={title}>
          <HeaderRight>
            <ChartSearchCheatSheet isShow={!payload} />
            <Settings id={`chart-settings-${id}`} title={title} widgetId={id} />
          </HeaderRight>
        </Header>
        <Content>
          <ChartContainer widgetId={id} chartSettings={payload} />
        </Content>
      </ChartProvider>
    </Widget>
  );
}
